import type { QueryClient } from "@tanstack/react-query";
import { updateDocumentLists } from "web_myplann/Api/Document/updateDocumentLists";

export const removeDocumentFromCache = (queryClient: QueryClient, id: number) =>
	updateDocumentLists(queryClient, (list) => ({
		...list,
		documents: list.documents.filter((document) => document.id !== id),
	}));
